import apiClient from "./apiClient"

export type RequestMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH"

interface RequestOptions<T = any> {
  url: string
  method?: RequestMethod
  data?: any
  params?: Record<string, any>
  headers?: Record<string, string>
}

export const request = async <T = any>({
  url,
  method = "GET",
  data,
  params,
  headers,
}: RequestOptions): Promise<T> => {
  const response = await apiClient.request<T>({
    url,
    method,
    data,
    params,
    headers,
  })

  return response.data
}
